import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.NetSuiteRequestCard.RequestCardItemReceipt', {
    referenceFieldText: 'Reference',
    vendorFieldText: 'Vendor',
    purchaseOrderFieldText: 'Purchase Order',
    transactionDateFieldText: 'Date',
    postingPeriodFieldText: 'Posting Period',
    memoFieldText: 'Memo',
});
